/* eslint-disable no-useless-escape */
/* eslint-disable radix */
/* eslint-disable max-len */
import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';

import {
  Row,
  Col,
  Input,
  Select,
  Checkbox,
  DatePicker,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {
  validators,
} from 'utils/validationMessages';

import { API_END_POINTS } from 'api';
import { MESSAGES } from 'appconstants';

import {
  SpForm,
  SpError,
  SpTextMute,
  SpText,
  SpCaption,
} from 'components/DesignKit';
import { InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';

import formatAmount from 'utils/formatAmount';

import KYCFileUpload from 'components/KycFileUpload';

const { Option } = Select;


let inpersonValue = 0;
const getInpersonValue = () => inpersonValue;

const setInpersonValue = (value) => {
  inpersonValue = value;
};

type Props = {
  isIndia: boolean,
  selectedAccount: Object,
  businessByDraft: Object,
}

const dateFormat = 'MMM DD, YYYY';

const BusinessBankDetails = (props: Props, ref) => {
  const { isIndia, selectedAccount, businessByDraft } = props;

  const [, forceUpdate] = useState();
  const [bankName, setBankName] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.bankName) ? businessByDraft.business.bankName : '');
  const [accountHolderName, setAccountHolderName] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.bankBeneficiaryName) ? businessByDraft.business.bankBeneficiaryName : '');
  const [accountNumber, setAccountNumber] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.bankAccountNumber) ? businessByDraft.business.bankAccountNumber : '');
  const [confirmAccountNumber, setConfirmAccountNumber] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.bankAccountNumber) ? businessByDraft.business.bankAccountNumber : '');
  const [bankRoutingNumber, setBankRoutingNumber] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.bankRoutingNumber) ? businessByDraft.business.bankRoutingNumber : '');
  const [ifscNumber, setIfscNumber] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.bankIfscCode) ? businessByDraft.business.bankIfscCode : '');
  const [bankStatementUrl, setBankStatementUrl] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.kycBankStatementUrl) ? businessByDraft.business.kycBankStatementUrl : '');
  const [accountType, setAccountType] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.bankAccountType) ? businessByDraft.business.bankAccountType : '');
  const [whenIsCardCharged, setWhenIsCardCharged] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.whenIsCardCharged) ? businessByDraft.business.whenIsCardCharged : null);
  const [averageMonthlyVolume, setAverageMonthlyVolume] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.averageMonthlyVolume && (businessByDraft.business.averageMonthlyVolume / 100).toFixed(2)) || '');
  const [averageTicketAmount, setAverageTicketAmount] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.averageTicketAmount && (businessByDraft.business.averageTicketAmount / 100).toFixed(2)) || '');
  const [servicesDeliveredIn, setServicesDeliveredIn] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.servicesDeliveredIn) ? businessByDraft.business.servicesDeliveredIn : '');
  const [refundPolicy, setRefundPolicy] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.refundPolicy) ? businessByDraft.business.refundPolicy : '');
  const [seasonalBusiness, setSeasonalBusiness] = useState(!!((businessByDraft && businessByDraft.business && businessByDraft.business.seasonalBusiness)));
  const [inPerson, setInPerson] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.modeOfTransactionPerson) ? [
    `${businessByDraft.business.modeOfTransactionPerson}%`,
    parseInt(businessByDraft.business.modeOfTransactionPerson),
  ] : '');
  const [online, setOnline] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.modeOfTransactionOnline) ? [
    `${businessByDraft.business.modeOfTransactionOnline}%`,
    parseInt(businessByDraft.business.modeOfTransactionOnline),
  ] : '');
  setInpersonValue((businessByDraft && businessByDraft.business && businessByDraft.business.modeOfTransactionPerson) ? [
    `${businessByDraft.business.modeOfTransactionPerson}%`,
    parseInt(businessByDraft.business.modeOfTransactionPerson),
  ] : 0);
  const [inpersonError, setInpersonError] = useState(false);
  const [EBTCheckBox, setEBTCheckBoxChange] = useState(businessByDraft?.business?.isEbt);
  const [isServiceDateFlexible, setIsServiceDateFlexible] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.isServiceDateFlexible) ? businessByDraft.business.isServiceDateFlexible : null);
  const [requestedServiceDate, setRequestedServiceDate] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.requestedServiceDate) ? businessByDraft.business.requestedServiceDate : '');
  const currencyType = selectedAccount && selectedAccount.currency;
  const accountRegex = /[0-9]{6,17}/;
  const routingRegex = /[0-9]{9}/;
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const averagemonthlyVolumeHandler = useRef();

  const EBTCheckBoxChange = (e) => {
    setEBTCheckBoxChange(e.target.checked);
  };

  const dateIssued = moment.utc(businessByDraft?.business?.requestedServiceDate).tz(selectedAccount.timezone).format(dateFormat);

  const defaultDate = () => (businessByDraft?.business?.requestedServiceDate ? moment(dateIssued, dateFormat) : '');


  const getPercentage = (inprocess, val) => {
    let result = 0;
    if (inprocess && val) {
      result = inprocess[1] + val[1];
    } if (inprocess && !val) {
      result = inprocess[1] + 0;
    } if (!inprocess && val) {
      result = 0 + val[1];
    }
    return `${result}%`;
  };

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      confirmAccount: {
        message: MESSAGES.BANK_DETAILS.MATCH,
        rule: (val, params) => val === params[0],
      },
      accountNumber: {
        message: MESSAGES.BANK_DETAILS.VALID,
        rule: val => accountRegex.test(val),
      },
      bankIFSC: {
        message: MESSAGES.BANK_DETAILS.IFSC,
        rule: val => ifscRegex.test(val),
      },
      bankRoutingNumber: {
        message: MESSAGES.BANK_DETAILS.ROUTING,
        rule: val => routingRegex.test(val),
      },
      bankNameValidation: {
        message: validators.bussiness.validBankName,
        rule: val => /^[A-Za-z0-9&,\s.\-'\$@_]{1,50}$/.test(val),
      },
      accountName: {
        message: validators.bussiness.validBankAccountName,
        rule: val => /^[A-Za-z0-9&,\s.\-'\$@_]{1,50}$/.test(val),
      },
      modeOfTransactionValditation: {
        message: 'Mode of transaction Online and In Person must add up to 100%',
        rule: (val) => (((getInpersonValue()[1] ? getInpersonValue()[1] : getInpersonValue()) + (val[1])) === 100),
      },
      averageTicketAmountCheck: {
        message: 'Average ticket amount should be less than average monthly amount',
        rule: (val) => Number(averagemonthlyVolumeHandler?.current?.input?.value.replaceAll(',', '')) > Number(val ? val.replaceAll(',', '') : 0.00),
      },

    },
  }));

  simpleValidator.current.purgeFields();

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (inPerson && online && (inPerson[1] + online[1] !== 100)) {
        setInpersonError(true);
        return false;
      }
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      return true;
    },
    getValues: () => ({
      bankName,
      accountHolderName,
      accountNumber,
      confirmAccountNumber,
      bankRoutingNumber,
      bankStatementUrl,
      accountType,
      ifscNumber,
      whenIsCardCharged,
      averageMonthlyVolume: averageMonthlyVolume ? averageMonthlyVolume.replace(/[^\d]/g, '') / 100 : '',
      averageTicketAmount: averageTicketAmount ? averageTicketAmount.replace(/[^\d]/g, '') / 100 : '',
      servicesDeliveredIn,
      refundPolicy,
      seasonalBusiness,
      modeOfTransactionOnline: online[1],
      modeOfTransactionPerson: inPerson[1],
      EBTCheckBox,
      requestedServiceDate,
      isServiceDateFlexible,
    }),
  }));

  return (
    <>
      <Row className="my-2 mb-3">
        <Col>
          <SpText className="text-uppercase" fontSize="20px">
            Manage Bank Details
          </SpText>
        </Col>
      </Row>
      <SpForm>

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Account Holder Name</span>
          </Col>
          <Col span={6}>
            <Input
              placeholder="Name of the account holder"
              value={accountHolderName}
              onBlur={() => setAccountHolderName(accountHolderName && accountHolderName.trim())}
              onChange={e => setAccountHolderName(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Account Holder Name', accountHolderName, 'required|accountName')}
            </SpError>
          </Col>
          <Col span={8} className="ml-4">
            <SpTextMute>
              Name should match the legal business name or legal
              name of the individual or sole proprietor
            </SpTextMute>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Bank Name</span>
          </Col>
          <Col span={6}>
            <Input
              placeholder="Bank Name"
              value={bankName}
              onBlur={() => setBankName(bankName && bankName.trim())}
              onChange={e => setBankName(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Bank name', bankName, 'required|bankNameValidation')}
            </SpError>
          </Col>
        </Row>

        {
          !isIndia && (
            <Row type="flex" justify="start" align="middle">
              <Col span={4}>
                <span>Account Type</span>
              </Col>
              <Col span={6}>
                <Select
                  placeholder="Select Account Type"
                  optionFilterProp="children"
                  className="w-100"
                  showSearch
                  value={accountType}
                  onChange={(value) => {
                    setAccountType(value);
                  }}
                >
                  <Option key={1} value="SAVINGS">SAVINGS</Option>
                  <Option key={2} value="CHECKING">CHECKING</Option>
                </Select>
                <SpError>
                  {simpleValidator.current.message('account Type', accountType, 'required')}
                </SpError>
              </Col>
            </Row>
          )
        }

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Account Number</span>
          </Col>
          <Col span={6}>
            <Input
              placeholder="Bank account number"
              value={accountNumber}
              onBlur={() => setAccountNumber(accountNumber && accountNumber.trim())}
              onChange={e => setAccountNumber(e.currentTarget.value)}
              onPaste={e => e.preventDefault()}
            />
            <SpError>
              {simpleValidator.current.message('Account Number', accountNumber, 'required|accountNumber')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Confirm Account No.</span>
          </Col>
          <Col span={6}>
            <Input
              placeholder="Confirm bank account number"
              value={confirmAccountNumber}
              onBlur={() => setConfirmAccountNumber(confirmAccountNumber && confirmAccountNumber.trim())}
              onChange={e => setConfirmAccountNumber(e.currentTarget.value)}
              onPaste={e => e.preventDefault()}
            />
            <SpError>
              {simpleValidator.current.message('Confirm Account Number', confirmAccountNumber, `required|confirmAccount:${accountNumber}`)}
            </SpError>
          </Col>
        </Row>

        {
          !isIndia && (
            <>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Routing Number</span>
                </Col>
                <Col span={6}>
                  <Input
                    placeholder="Routing number"
                    value={bankRoutingNumber}
                    onBlur={() => setBankRoutingNumber(bankRoutingNumber && bankRoutingNumber.trim())}
                    onChange={e => setBankRoutingNumber(e.currentTarget.value)}
                  />
                  <SpError>
                    {simpleValidator.current.message('Bank Routing Number', bankRoutingNumber, 'required|bankRoutingNumber')}
                  </SpError>
                </Col>
              </Row>

              <Row>
                <div style={{ display: 'flex', alignItems: 'start', marginBottom: 16 }}>
                  <InfoCircleOutlined style={{
                    color: 'rgb(255 167 0)', marginRight: 8, marginTop: 3, fontSize: 20,
                  }}
                  />
                  <span>
                    After successful submission, you will receive an email notification with a
                    secure link to upload the void check or bank Letter/statement documents.
                  </span>
                </div>
              </Row>

              <Row className="my-2 mb-3" style={{ marginLeft: '-16px' }}>
                <Col>
                  <SpText className="text-uppercase" fontSize="20px">
                    Processing Information
                  </SpText>
                </Col>
              </Row>

              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Average Monthly Volume ($)</span>
                </Col>
                <Col span={6}>
                  <Input
                    value={averageMonthlyVolume}
                    placeholder="0.00"
                    ref={averagemonthlyVolumeHandler}
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setAverageMonthlyVolume(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setAverageMonthlyVolume(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, currencyType);
                        setAverageMonthlyVolume(value);
                      }
                    }}
                  />
                  <SpError>
                    {simpleValidator.current.message('average monthly volume', averageMonthlyVolume, 'required')}
                  </SpError>
                </Col>
              </Row>

              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Average Ticket Amount ($)</span>
                </Col>
                <Col span={6}>
                  <Input
                    value={averageTicketAmount}
                    placeholder="0.00"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setAverageTicketAmount(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setAverageTicketAmount(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, currencyType);
                        setAverageTicketAmount(value);
                      }
                    }}
                  />
                  <SpError>
                    {simpleValidator.current.message('average ticket amount', averageTicketAmount, 'required|averageTicketAmountCheck')}
                  </SpError>
                </Col>
              </Row>

              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>When Are Goods and Services Typically Delivered?</span>
                </Col>
                <Col span={6}>
                  <Select
                    placeholder="Services delivered in"
                    optionFilterProp="children"
                    className="w-100"
                    showSearch
                    value={servicesDeliveredIn}
                    onChange={(value) => {
                      setServicesDeliveredIn(value);
                    }}
                  >
                    <Option key={1} value="ZERO_TO_SEVEN_DAYS">0-7 Days</Option>
                    <Option key={2} value="EIGHT_TO_FOURTEEN_DAYS">8-14 Days</Option>
                    <Option key={3} value="FIFTEEN_TO_THIRTY_DAYS">15-30 Days</Option>
                    <Option key={4} value="OVER_THIRTY_DAYS">Over 30 Days</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('services delivered in', servicesDeliveredIn, 'required')}
                  </SpError>
                </Col>
              </Row>

              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>What is Your Current Refund Policy?</span>
                </Col>
                <Col span={6}>
                  <Select
                    placeholder="Select refund policy"
                    optionFilterProp="children"
                    className="w-100"
                    showSearch
                    value={refundPolicy}
                    onChange={(value) => {
                      setRefundPolicy(value);
                    }}
                  >
                    <Option key={1} value="EXCHANGE_ONLY">Exchange Only</Option>
                    <Option key={2} value="NO_REFUND_OR_EXCHANGE">No Refund or Exchange</Option>
                    <Option key={3} value="MORE_THAN_THIRTY_DAYS">More than 30 Days</Option>
                    <Option key={4} value="THIRTY_DAYS_OR_LESS">30 Days or Less</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('refund policy', refundPolicy, 'required')}
                  </SpError>
                </Col>
              </Row>

              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Do Customers Typically Receive Goods/Services at the Time of Purchase?</span>
                </Col>
                <Col span={6}>
                  <Select
                    placeholder="When card is charged"
                    optionFilterProp="children"
                    className="w-100"
                    showSearch
                    value={whenIsCardCharged}
                    onChange={(value) => {
                      setWhenIsCardCharged(value);
                    }}
                  >
                    <Option key={1} value="WHEN_SERVICE_PROVIDED">Yes</Option>
                    <Option key={2} value="IN_ADVANCE">No</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('when is card charged', whenIsCardCharged, 'required')}
                  </SpError>
                </Col>
              </Row>

              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Is Your Business Seasonal or do you Process Payments Throughout the Year?</span>
                </Col>
                <Col span={6}>
                  <Select
                    placeholder="Select seasonal business"
                    optionFilterProp="children"
                    className="w-100"
                    showSearch
                    value={seasonalBusiness}
                    onChange={(value) => {
                      setSeasonalBusiness(value);
                    }}
                  >
                    <Option key={1} value>SEASONAL</Option>
                    <Option key={2} value={false}>ALL YEAR</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('seasonal business', seasonalBusiness, 'required')}
                  </SpError>
                </Col>
              </Row>

              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Mode of Transaction</span>
                </Col>
                <Col span={6} />
              </Row>
              <Row type="flex" className="mt-2" justify="start" align="middle">
                <Col span={4} />
                <Col span={2}>
                  <span>In Person</span>
                </Col>
                <Col span={4}>
                  <Select
                    placeholder="Select in person"
                    optionFilterProp="children"
                    className="w-100"
                    showSearch
                    value={inPerson[0]}
                    onChange={(value) => {
                      setInPerson(value);
                      setInpersonValue(value);
                      setInpersonError(false);
                    }}
                  >
                    <Option key={1} value={['0%', 0]}>0%</Option>
                    <Option key={2} value={['25%', 25]}>25% </Option>
                    <Option key={3} value={['50%', 50]}>50%</Option>
                    <Option key={4} value={['75%', 75]}>75%</Option>
                    <Option key={5} value={['100%', 100]}>100%</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('in person', inPerson, 'required')}
                  </SpError>
                </Col>
                {(inPerson[1] > 0) && (
                  <Col span={8} className="ml-4">
                    <Checkbox onChange={EBTCheckBoxChange} checked={EBTCheckBox}>Accept Electronic Benefits Transfer (EBT) Payments</Checkbox>
                  </Col>
                )}
              </Row>

              <Row type="flex" className="mt-2" justify="start" align="middle">
                <Col span={4} />
                <Col span={2}>
                  <span>Online</span>
                </Col>
                <Col span={4}>
                  <Select
                    placeholder="Select online"
                    optionFilterProp="children"
                    className="w-100"
                    showSearch
                    value={online[0]}
                    onChange={(value) => {
                      setOnline(value);
                      setInpersonError(false);
                    }}
                  >
                    <Option key={1} value={['0%', 0]}>0%</Option>
                    <Option key={2} value={['25%', 25]}>25% </Option>
                    <Option key={3} value={['50%', 50]}>50%</Option>
                    <Option key={4} value={['75%', 75]}>75%</Option>
                    <Option key={5} value={['100%', 100]}>100%</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('online', online, 'required')}
                  </SpError>
                  {
                    inpersonError ? (
                      <SpError>
                        Mode of transaction Online and In Person must add up to 100%
                      </SpError>
                    ) : (
                      <></>
                    )
                  }
                </Col>
              </Row>

              <Row type="flex" className="mt-2" justify="start" align="middle">
                <Col span={4} />
                <Col span={2}>
                  <span>Total</span>
                </Col>
                <Col span={4} align="right" justify="end">
                  <span>
                    {getPercentage(inPerson, online)}
                  </span>
                </Col>
              </Row>
              {(inPerson[1] > 0) && (
                <Row type="flex" justify="start" align="middle">
                  <Col span={4}>
                    <span>Requested Service Date</span>
                  </Col>
                  <Col span={6}>
                    <DatePicker
                      defaultValue={defaultDate()}
                      allowClear={false}
                      onChange={(date, dateString) => setRequestedServiceDate(dateString)}
                      disabledDate={current => current && current < moment().subtract(1, 'days')}
                    />
                  </Col>
                  <Col>
                    <SpCaption className="pl-4">(Optional)</SpCaption>
                  </Col>
                </Row>
              )}
              {(inPerson[1] > 0) && (
                <Row type="flex" justify="start" align="middle">
                  <Col span={4}>
                    <span>Is Service Date Flexible</span>
                  </Col>
                  <Col span={6}>
                    <Select
                      placeholder="Is Service Date Flexible"
                      optionFilterProp="children"
                      className="w-100"
                      showSearch
                      value={isServiceDateFlexible}
                      onChange={(value) => {
                        setIsServiceDateFlexible(value);
                      }}
                    >
                      <Option key={1} value>Yes</Option>
                      <Option key={2} value={false}>No</Option>
                    </Select>
                  </Col>
                  <Col>
                    <SpCaption className="pl-4">(Optional)</SpCaption>
                  </Col>
                </Row>
              )}
            </>
          )
        }

        {
          isIndia && (
            <>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>IFSC Number</span>
                </Col>
                <Col span={6}>
                  <Input
                    placeholder="IFSC number"
                    value={ifscNumber}
                    onBlur={() => setIfscNumber(ifscNumber && ifscNumber.trim())}
                    onChange={e => setIfscNumber((e.currentTarget.value).toUpperCase())}
                  />
                  <SpError>
                    {simpleValidator.current.message('ifsc Number', ifscNumber, 'required|bankIFSC',
                      { messages: { required: 'The IFSC Number field is required.' } })}
                  </SpError>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Bank Account Statement</span>
                </Col>
                <Col span={6}>
                  <KYCFileUpload
                    name="Bank Statement"
                    endPoint={API_END_POINTS.UPLOAD_BANK_STATEMENT}
                    url={bankStatementUrl}
                    setUrl={value => setBankStatementUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('Bank statement proof', bankStatementUrl, 'required')}
                  </SpError>
                </Col>
                <Col span={8} className="ml-4">
                  <SpTextMute>
                    Upload an Image or pdf with bank account number, IFSC code,
                    company name all in one document. Self attested mandatory.
                  </SpTextMute>
                </Col>
              </Row>
            </>
          )
        }
      </SpForm>
    </>
  );
};

// $FlowFixMe
export default forwardRef(BusinessBankDetails);
